import styled from 'styled-components'
import Icon from './Icon'

const EditIcon = styled(Icon).attrs({
  type: 'pencil',
})``

export default EditIcon
